/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Integrations_Dialog_SaveInputs */



/**
* | output |
* | --- |
* | "Save" |
*
* @param {Integrations_Dialog_SaveInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const integrations_dialog_save = /** @type {((inputs?: Integrations_Dialog_SaveInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Integrations_Dialog_SaveInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Speichern")
	return /** @type {LocalizedString} */ ("Save")
});